var styleDataHash = "8610236a";
const injectCss = () => {
  var css = `.yYe5l{width:1px}.vAkTW{aspect-ratio:1/1;flex:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var button_color_swatches_default = {
  "divider": "yYe5l",
  "fillPreview": "vAkTW"
};
export {
  button_color_swatches_default as default,
  injectCss
};
//# sourceMappingURL=button-color-swatches-scss.js.map
